import { render } from "./LazyImage.vue?vue&type=template&id=39975176&scoped=true&ts=true"
import script from "./LazyImage.vue?vue&type=script&lang=ts"
export * from "./LazyImage.vue?vue&type=script&lang=ts"

import "./LazyImage.vue?vue&type=style&index=0&id=39975176&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39975176"]])

export default __exports__